/*
Sohel 09/21/2022  2698592321  Fixed Client Maintainance Bugs
Suresh Peddavoora 10/30/2022 2698592321  Added Class Name for Table and Buttons Enhancements
saikrishna 11/03/2022 2698592321 changed the paginationOptions
akhila 11/03/2022 2698592321 TablePagination bugFix
*/
import React, {useState, useContext, createRef} from 'react';
import {httpPaginationPost} from '../../../util/Rest';
import {useDispatch} from 'react-redux';
// import MaterialTable from "material-table";
import Grid from '@material-ui/core/Grid';
import {useHistory} from 'react-router';
import {makeStyles, TablePagination, Button} from '@material-ui/core';
import {tableIcons} from '../../../components/TableIcons';
import {Link} from 'react-router-dom';
import SelectTabContextProvider from '../../../components/SelectTabContext/SelectTabContext';
import {defaultRows, tablePageRows} from '../../../constants/ReusableConstants';
import AddIcon from '@material-ui/icons/Add';
import TableHeaderText from '../../../util/TableHeaderText';
import {useSelector} from 'react-redux';
import {ThemeContext} from '../../../themes/ThemeProvider';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {ArrowBack} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  link: {
    color: '#320469 !important',
  },
}));

export default function ParentClientTable() {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes1 = reusableInputStyles();
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const tableRef = createRef();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [countTotal, setCountTotal] = useState(null);
  const {search} = useContext(SelectTabContextProvider);
  const {roleData} = useSelector(({role}) => role);
  const disabledByRole = roleData?.window?.['Client Maintenance']?.PC;
  const columns = [
    {
      title: 'Parent Client Id',
      field: 'parentClientId',
      render: (rowData) => {
        return rowData && rowData.parentClientId ? (
          <Link
            to={{
              pathname: `/add-parent-form`,
              state: {parentData: rowData},
            }}
            className={classes.link}
          >
            {rowData.parentClientId}
          </Link>
        ) : null;
      },
    },
    {
      title: 'Parent Client Name',
      field: 'parentClientName',
      render: (rowData) => {
        return rowData?.parentClientName ? <>{rowData.parentClientName}</> : <span>---</span>;
      },
    },
    {
      title: 'City',
      field: 'city',
    },

    {
      title: 'State',
      field: 'state',
    },
    {
      title: 'ZipCode',
      field: 'zip',
    },
  ];
  return (
    <>
      <Grid item md={12} lg={12} sm={12}>
        <div className="add-parent-client-btn">
          <Button

            type="button"
            variant="outlined"
            className={`search-btn ${classes1.buttonRoot}`}
            onClick={() => {
              history.push('/client-search');
            }}
          >
            <ArrowBack className="mr-2" />
            BACK TO DASHBOARD
          </Button>
          <Button
            variant="outlined"
            className={`search-btn ${classes1.buttonRoot}`}
            onClick={() => history.push('/add-parent-form')}
            disabled={!disabledByRole?.add}
          >
            <AddIcon />
            Add Parent Client
          </Button>
        </div>
      </Grid>
      <Grid item xs={12} className="">
        <div className="custom-table global-field-table">
          <GuiTable
            title={<TableHeaderText countTotal={countTotal} />}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `maintenance/find/all/parentclient`;
                const bodyObj = {
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query.orderDirection,
                  page: search ?
                    1 :
                    arrayLast && query.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  search: query.search.trim(),
                };

                httpPaginationPost(url, bodyObj)
                  .then((response) => {
                    if (response?.status === 200) {
                      resolve({
                        data: response.data.response.resultObjects ?
                          response.data.response.resultObjects :
                          [],
                        page: response.data.response.page - 1,
                        totalCount: response.data.response.count,
                      });
                      setCountTotal(response?.data?.response?.count);
                      setArrayLast(response?.data?.response?.resultObjects?.length === 1);
                    } else {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    }
                  })
                  .catch((response) => {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              })
            }
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
            options={{
              search: true,
              debounceInterval: 500,
              toolbar: false,
              pageSize: rows,
              pageSizeOptions: tablePageRows,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
              rowStyle: (data, index) => {
                if (data.tableData && data.tableData.checked) {
                  return {
                    backgroundColor: '#FFFFFF',
                    opacity: 1,
                  };
                }
              },
            }}
            onSelectionChange={(rows) => rows}
          />
        </div>
      </Grid>
    </>
  );
}
